exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#btnExportCsv[data-v-0e34d032] {\n  height: auto;\n}\n.container-custom[data-v-0e34d032] {\n  width: 100%; /* Puedes ajustar este valor según tus necesidades */\n  margin: 0 auto;\n}\n.v-card[data-v-0e34d032] {\n  display: inline-block;\n  word-wrap: break-word;\n}\n.no-bg[data-v-0e34d032] {\n  -webkit-box-shadow: none !important;\n}\n", ""]);

// exports
